import { Component, OnInit, Input, Optional, Inject } from '@angular/core';

@Component({
    selector: 'component-title',
    templateUrl: './component-title.component.html'
})
export class ComponentTitleComponent implements OnInit {
    themeType: string;
    // @input theme has to be removed
    @Input() theme: string;
    @Input() portletTitle: string = '';
    // Page specific - per Ed:  NS-4242...For example in the Conservative theme,
    // the titles and borders are enabled for some portlets but not enabled for most grids.
    @Input() showTitle: boolean = true;

    bordersStyles: string = '';
    @Input() set showBorders(showBorders: boolean) {
        this.bordersStyles = !!showBorders && showBorders ? 'portlet-topper' : '';
    }

    // Override showBorder with whatever styles passed in
    @Input() set customBorders(customBorders: string) {
        this.bordersStyles = !!customBorders ? customBorders : '';
    }

    constructor(@Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.themeType = 'ada';
        } else {
            this.themeType = 'standard';
        }
    }

    ngOnInit() {}
}
